import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=30704c95&"
import script from "./ProfileMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=30704c95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports